/**
 * External dependencies
 */
import type { ExperimentId } from '@nab/types';

/**
 * Internal dependencies
 */
import { getCookie, setCookie } from '../cookies';

export type SegmentationSettings = {
	readonly activeSegments: Partial<
		Record< ExperimentId, ReadonlyArray< number > >
	>;
	readonly alternativeChecksum: string;
	readonly firstVisit: number;
	readonly extra: {
		readonly browser: string;
		readonly device: string;
		readonly ipAddress: string;
		readonly location: string;
		readonly os: string;
		readonly lastUpdate: string;
	};
};

export function updateFirstVisit(): void {
	const settings = getSegmentationSettings();
	setSegmentationSettings( {
		...settings,
		firstVisit:
			settings.firstVisit ||
			Number.parseInt( Date.now().toString() ) ||
			0,
	} );
}

export const DEFAULT_SEGMENTATION_SETTINGS: SegmentationSettings = {
	activeSegments: {},
	alternativeChecksum: '',
	extra: {
		browser: '',
		device: '',
		location: '',
		ipAddress: '',
		os: '',
		lastUpdate: '',
	},
	firstVisit: 0,
};
export function getSegmentationSettings(): SegmentationSettings {
	try {
		const settings = JSON.parse(
			getCookie( 'nabSegmentation' ) || '{}'
		) as Partial< SegmentationSettings >;
		return {
			activeSegments:
				settings.activeSegments ??
				DEFAULT_SEGMENTATION_SETTINGS.activeSegments,
			alternativeChecksum:
				settings.alternativeChecksum ??
				DEFAULT_SEGMENTATION_SETTINGS.alternativeChecksum,
			extra: {
				...DEFAULT_SEGMENTATION_SETTINGS.extra,
				...( settings.extra || {} ),
			},
			firstVisit:
				settings.firstVisit ?? DEFAULT_SEGMENTATION_SETTINGS.firstVisit,
		};
	} catch ( _ ) {
		return DEFAULT_SEGMENTATION_SETTINGS;
	}
}

export function setSegmentationSettings(
	settings: SegmentationSettings
): void {
	setCookie( 'nabSegmentation', JSON.stringify( settings ), {
		expires: 120,
	} );
}
